import React, {useEffect, useState} from "react";
import {
  // aboutIcon1,
  // aboutIcon2,
  // aboutIcon3,
  // rightImage,
  serviceIcon1,
  // serviceIcon2,
  // serviceIcon3,
  avatarLeft,
  sliderIcon,
} from "../../assets/images";
import Flickity from "react-flickity-component";
import {course} from "../../config/course";
import {slideToggle, slideUp} from "../../utility";
import {frequentlyQuestion} from "../../config/frequentlyQuestion";

const nameOwner = "Toản Nguyễn";
const phoneOwner = "0927484848";
const emailOwner = "nguyentoan.tt38@gmail.com";
const facebookOwner = "https://www.facebook.com/profile.php?id=100003876634394";

const FormController = () => {
  // const [isSend, setIsSend] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessge] = useState(
    "Xin Chào Thầy, tôi muốn đăng kí học lái xe."
  );

  const sendFeedback = (templateId, variables) => {
    window.emailjs
      .send("gmail", templateId, variables)
      .then((res) => {
        console.log("Email successfully sent!");
      })
      // Handle errors here however you like, or use a React error boundary
      .catch((err) =>
        console.error(
          "Oh well, you failed. Here some thoughts on the error that occured:",
          err
        )
      );
  };

  const resetValues = () => {
    setName("");
    setEmail("");
    setPhone("");
    setMessge("Xin Chào Thầy, tôi muốn đăng kí học lái xe.");
  };

  const sendMail = async (e) => {
    e.preventDefault();
    if (!name || !email || !phone) {
      console.log("Action không thực hiện");
      return;
    }

    try {
      // gửi về Teacher
      await sendFeedback("template_pGut9rPQ", {
        message_html: `${name} - ${phone}`,
        from_name: nameOwner,
        send_to: emailOwner,
      });
      // gửi về Customer
      await sendFeedback("email_customer", {
        message_html: phoneOwner,
        from_name: nameOwner,
        send_to: email,
        to_name: name,
      });
      resetValues();
    } catch (error) {
      console.log("error send email");
    }
  };
  return (
    <form id="contact" action="true" onSubmit={sendMail}>
      <div className="row">
        <div className="col-md-6 col-sm-12">
          <fieldset>
            <input
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              id="name"
              placeholder="Tên của bạn"
              required
              className="contact-field"
            />
          </fieldset>
        </div>
        <div className="col-md-6 col-sm-12">
          <fieldset>
            <input
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="text"
              id="email"
              placeholder="E-mail của bạn"
              required
              className="contact-field"
            />
          </fieldset>
        </div>
        <div className="col-sm-12">
          <fieldset>
            <input
              name="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              type="text"
              id="phone"
              placeholder="Số điện thoại của bạn"
              required
              className="contact-field"
            />
          </fieldset>
        </div>
        <div className="col-lg-12">
          <fieldset>
            <textarea
              name="message"
              value={message}
              onChange={(e) => setMessge(e.target.value)}
              rows={6}
              id="message"
              placeholder="Your Message"
              required
              className="contact-field"
            />
          </fieldset>
        </div>
        <div className="col-lg-12">
          <fieldset>
            <button type="submit" id="form-submit" className="main-button">
              Gửi yêu cầu
            </button>
          </fieldset>
        </div>
      </div>
    </form>
  );
};

export const DHome = () => {
  useEffect(() => {
    const Accordion = {
      settings: {
        // Expand the first item by default
        first_expanded: false,
        // Allow items to be toggled independently
        toggle: false,
      },

      openAccordion: function (toggle, content) {
        if (content.children.length) {
          toggle.classList.add("is-open");
          let final_height = Math.floor(content.children[0].offsetHeight);
          content.style.height = final_height + "px";
        }
      },

      closeAccordion: function (toggle, content) {
        toggle.classList.remove("is-open");
        content.style.height = 0;
      },

      init: function (el) {
        const _this = this;

        // Override default settings with classes
        let is_first_expanded = _this.settings.first_expanded;
        if (el.classList.contains("is-first-expanded"))
          is_first_expanded = true;
        let is_toggle = _this.settings.toggle;
        if (el.classList.contains("is-toggle")) is_toggle = true;

        // Loop through the accordion's sections and set up the click behavior
        const sections = el.getElementsByClassName("accordion");
        const all_toggles = el.getElementsByClassName("accordion-head");
        const all_contents = el.getElementsByClassName("accordion-body");
        for (let i = 0; i < sections.length; i++) {
          const section = sections[i];
          const toggle = all_toggles[i];
          const content = all_contents[i];

          // Click behavior
          toggle.addEventListener("click", function (e) {
            if (!is_toggle) {
              // Hide all content areas first
              for (let a = 0; a < all_contents.length; a++) {
                _this.closeAccordion(all_toggles[a], all_contents[a]);
              }

              // Expand the clicked item
              _this.openAccordion(toggle, content);
            } else {
              // Toggle the clicked item
              if (toggle.classList.contains("is-open")) {
                _this.closeAccordion(toggle, content);
              } else {
                _this.openAccordion(toggle, content);
              }
            }
          });

          // Expand the first item
          if (i === 0 && is_first_expanded) {
            _this.openAccordion(toggle, content);
          }
        }
      },
    };

    (function () {
      // Initiate all instances on the page
      const accordions = document.getElementsByClassName("accordions");
      for (let i = 0; i < accordions.length; i++) {
        Accordion.init(accordions[i]);
      }
    })();

    (function () {
      let menuTrigger = document.querySelectorAll(".menu-trigger");
      let headerArea = document.querySelector(".header-area .nav");
      if (menuTrigger.length) {
        menuTrigger[0].addEventListener("click", function () {
          menuTrigger[0].classList.toggle("active");
          slideToggle(headerArea, 200);
        });
      }
    })();

    // Menu elevator animation
    (function () {
      const hrefMenus = document.querySelectorAll(
        "a[href*=\\#]:not([href=\\#])"
      );
      let menuTrigger = document.querySelectorAll(".menu-trigger");
      let headerArea = document.querySelector(".header-area .nav");

      for (let i = 0; i < hrefMenus.length; i++) {
        hrefMenus[i].addEventListener("click", function () {
          if (
            // window.location.pathname.replace(/^\//, "") ===
            //   this.pathname.replace(/^\//, "") &&
            window.location.hostname === this.hostname
          ) {
            var target = document.querySelector(this.hash);
            console.log("sss", this.hash, target);
            target = target
              ? target
              : document.querySelector("[name=" + this.hash.slice(1) + "]");
            if (target) {
              console.log("window.innerWidth : ", window.innerWidth);
              var width = window.innerWidth;
              if (width < 991) {
                menuTrigger[0].classList.remove("active");
                slideUp(headerArea, 200);
                // $(".header-area .nav").slideUp(200);
              }
              // $("html,body").animate(
              //   {
              //     scrollTop: target.offset().top - 80,
              //   },
              //   700
              // );
              return false;
            }
          }
        });
      }
    })();
  }, []);

  return (
    <div>
      {/* ***** Preloader Start ***** */}
      <div id="preloader">
        <div className="jumper">
          <div />
          <div />
          <div />
        </div>
      </div>
      {/* ***** Preloader End ***** */}
      {/* ***** Header Area Start ***** */}
      <header className="header-area header-sticky">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <nav className="main-nav">
                {/* ***** Logo Start ***** */}
                <a href="#" className="logo">
                  {/* Driving Instructor */}
                  Thầy Toản
                </a>
                {/* ***** Logo End ***** */}
                {/* ***** Menu Start ***** */}
                <ul className="nav">
                  <li className="scroll-to-section">
                    <a href="#welcome" className="active">
                      Trang Chủ
                    </a>
                  </li>
                  <li className="scroll-to-section">
                    <a href="#about">Về tôi</a>
                  </li>
                  <li className="scroll-to-section">
                    <a href="#services">Dịch vụ</a>
                  </li>
                  {/* <li class="scroll-to-section"><a href="#frequently-question">Frequently Questions</a></li>
                    <li class="submenu">
                        <a href="javascript:;">Drop Down</a>
                        <ul>
                            <li><a href="">About Us</a></li>
                            <li><a href="">Features</a></li>
                            <li><a href="">FAQ's</a></li>
                            <li><a href="">Blog</a></li>
                        </ul>
                    </li> */}
                  <li className="scroll-to-section">
                    <a href="#contact-us">Liên lạc</a>
                  </li>
                </ul>
                <a className="menu-trigger">
                  <span>Menu</span>
                </a>
                {/* ***** Menu End ***** */}
              </nav>
            </div>
          </div>
        </div>
      </header>
      {/* ***** Header Area End ***** */}
      {/* ***** Welcome Area Start ***** */}
      <div className="welcome-area" id="welcome">
        {/* ***** Header Text Start ***** */}
        <div className="header-text">
          <div className="container">
            <div className="row">
              <div
                className="left-text col-lg-6 col-md-6 col-sm-12 col-xs-12"
                data-scroll-reveal="enter left move 30px over 0.6s after 0.4s"
              >
                <h1>
                  Khóa học lái xe <strong>dành cho BẠN</strong>
                </h1>
                <p>
                  Khóa học được dẫn dắt bởi thầy Toản tại thị xa Buôn Hồ, tỉnh
                  Đăk Lăk. Thầy Toản với nhiều năm kinh nghiệm trong việc giảng
                  dạy sẽ là lựa chọn chính xác của bạn.
                </p>
                <a href="#contact-form" className="main-button-slider">
                  Đăng kí ngay
                </a>
              </div>
              <div
                className="col-lg-6 col-md-6 col-sm-12 col-xs-12"
                data-scroll-reveal="enter right move 30px over 0.6s after 0.4s"
              >
                <img
                  src={sliderIcon}
                  style={{
                    visibility: "visible",
                    animationDuration: "1.8s",
                    animationDelay: "0.2s",
                    animationName: "fadeIn",
                  }}
                  className="rounded img-fluid d-block mx-auto wow fadeIn"
                  alt="First Vector Graphic"
                />
              </div>
            </div>
          </div>
        </div>
        {/* ***** Header Text End ***** */}
      </div>
      {/* ***** Welcome Area End ***** */}
      {/* ***** Features Big Item Start ***** */}
      <section className="section" id="about">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-7 col-md-12 col-sm-12"
              data-scroll-reveal="enter left move 30px over 0.6s after 0.4s"
            >
              <img
                src={avatarLeft}
                style={{
                  visibility: "visible",
                  animationDuration: "1s",
                  animationDelay: "0.2s",
                  animationName: "fadeInLeft",
                }}
                className="rounded img-fluid d-block mx-auto wow fadeInLeft"
                alt="App"
              />
            </div>
            <div
              className="right-text col-lg-5 col-md-12 col-sm-12 mobile-top-fix wow fadeInRight"
              style={{
                visibility: "visible",
                animationDuration: "1s",
                animationDelay: "0.2s",
                animationName: "fadeInRight",
              }}
            >
              <div className="left-heading">
                <h5>Toản Nguyễn</h5>
              </div>
              <div className="left-text">
                <p>
                  Giáo viên của <a href="#">Trung tâm GDNN BẢO AN </a>
                  tại thị xã Buôn Hồ, tỉnh Đăk Lăk. Tôi sẽ trực tiếp đứng lớp và
                  đảm nhận vài trò đào tạo dạy các học viên thực hành. <br />
                  <br />
                  Là một giáo viên nghiêm khắc khi trực tiếp dạy cho các học
                  viên. Tôi hi vọng có thể giúp các bạn học viên hiểu và nắm bắt
                  được những lý thuyết và kĩ năng cần có trong quá trình học lái
                  xe.
                </p>
                {/* <a href="#about2" className="main-button">
                  Discover More
                </a> */}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="hr" />
            </div>
          </div>
        </div>
      </section>
      {/* ***** Features Big Item End ***** */}
      {/* ***** Features Big Item Start ***** */}
      {/* <section class="section" id="about2">
        <div class="container">
          <div class="row">
            <div class="left-text col-lg-5 col-md-12 col-sm-12 mobile-bottom-fix">
              <div class="left-heading">
                <h5>Curabitur aliquam eget tellus id porta</h5>
              </div>
              <p>
                Proin justo sapien, posuere suscipit tortor in, fermentum mattis
                elit. Aenean in feugiat purus.
              </p>
              <ul>
                <li>
                  <img src={aboutIcon1} alt="" />
                  <div class="text">
                    <h6>Nulla ultricies risus quis risus</h6>
                    <p>
                      You can use this website template for commercial or
                      non-commercial purposes.
                    </p>
                  </div>
                </li>
                <li>
                  <img src={aboutIcon2} alt="" />
                  <div class="text">
                    <h6>Donec consequat commodo purus</h6>
                    <p>
                      You have no right to re-distribute this template as a
                      downloadable ZIP file on any website.
                    </p>
                  </div>
                </li>
                <li>
                  <img src={aboutIcon3} alt="" />
                  <div class="text">
                    <h6>Sed placerat sollicitudin mauris</h6>
                    <p>
                      If you have any question or comment, please{" "}
                      <a rel="nofollow" href="https://templatemo.com/contact">
                        contact
                      </a>{" "}
                      us on TemplateMo.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div
              class="right-image col-lg-7 col-md-12 col-sm-12 mobile-bottom-fix-big"
              data-scroll-reveal="enter right move 30px over 0.6s after 0.4s"
            >
              <img
                src={rightImage}
                class="rounded img-fluid d-block mx-auto"
                alt="App"
              />
            </div>
          </div>
        </div>
      </section> */}
      {/* ***** Features Big Item End ***** */}
      {/* ***** Features Small Start ***** */}
      <section className="section" id="services">
        <div className="container">
          <Flickity
            // // className="box-list-banner"
            options={{
              imagesLoaded: true,
              contain: true,
              // disable previous & next buttons and dots
              prevNextButtons: false,
              // pageDots: false,
              autoPlay: true,
              groupCells: true,
            }}
          >
            {course.map((item, idx) => (
              <div key={idx} className="item service-item">
                <div className="icon">
                  <i>
                    <img src={serviceIcon1} alt="" />
                  </i>
                </div>
                <h5 className="service-title">{item.title}</h5>
                {item.subTitle && <h4>{item.subTitle}</h4>}
                <div>
                  {item.content.length > 0 &&
                    item.content.map((content, idy) => (
                      <div key={idy} className="d-flex align-items-center">
                        <i className="fa fa-check-square-o mr-2" />
                        <p>{content}</p>
                      </div>
                    ))}
                </div>
                {/* <a href="#" className="main-button">
                  Chi tiết
                </a> */}
              </div>
            ))}
          </Flickity>
        </div>
      </section>

      {/* ***** Features Small End ***** */}
      {/* ***** Frequently Question Start ***** */}
      <section className="section" id="frequently-question">
        <div className="container">
          {/* ***** Section Title Start ***** */}
          <div className="row">
            <div className="col-lg-12">
              <div className="section-heading">
                <h2>Các câu hỏi thường gặp</h2>
              </div>
            </div>
            {/* <div className="offset-lg-3 col-lg-6">
              <div className="section-heading">
                <p>
                  Vivamus venenatis eu mi ac mattis. Maecenas ut elementum
                  sapien. Nunc euismod risus ac lobortis congue. Sed erat quam.
                </p>
              </div>
            </div> */}
          </div>
          {/* ***** Section Title End ***** */}
          <div className="row">
            <div
              className="left-text col-lg-6 col-md-6 col-sm-12 wow fadeInLeft"
              style={{
                visibility: "visible",
                animationDuration: "1s",
                animationDelay: "0.2s",
                animationName: "fadeInLeft",
              }}
            >
              <h5>CÁC CÂU HỎI THƯỜNG GẶP KHI ĐĂNG KÝ HỌC LÁI XE Ô TÔ</h5>
              <div className="accordion-text">
                <p>
                  Ô tô là một phương tiện phổ biến tại đường bộ giao thông Việt
                  Nam. Bạn đang có nhu cầu học lái nhưng vẫn đang có nhiều câu
                  hỏi còn thắc mắc về quy trình và quá trình học lái xe ô tô.
                  Trường dạy lái xe quận sẽ giúp bạn giải đáp thắc mắc đó qua
                  bài viết bên dưới.
                </p>
                {/* <p>Sed lobortis pellentesque magna ac congue. Suspendisse quis molestie magna, id eleifend ex. Ut mollis ultricies diam nec dictum. Morbi commodo hendrerit mi vel vulputate. Proin non tincidunt dui. Lorem ipsum dolor sit amet.</p> */}
                <span>
                  Email: <a href="#">{emailOwner}</a>
                  <br />
                </span>
                <a href="#contact-us" className="main-button">
                  Liên hệ ngay
                </a>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div
                className="accordions is-first-expanded wow fadeIn"
                style={{
                  visibility: "visible",
                  animationDuration: "0.2s",
                  animationDelay: "1s",
                  animationName: "fadeIn",
                }}
              >
                {frequentlyQuestion.map((item, idx) => (
                  <article
                    key={idx}
                    className="accordion wow fadeInRight"
                    style={{
                      visibility: "visible",
                      animationDuration: "1s",
                      animationDelay: `${idx / 7 + 1.5}s`,
                      animationName: "fadeInRight",
                    }}
                  >
                    <div className="accordion-head">
                      <span>{item.question}</span>
                      <span className="icon">
                        <i className="icon fa fa-chevron-right" />
                      </span>
                    </div>
                    <div className="accordion-body">
                      <div className="content">
                        {item.answers.map((answer, idy) => (
                          <p key={idy}>{answer}</p>
                        ))}
                        <p>
                          Theo quy định của nhà nước, Bằng lái xe ô tô và bằng
                          lái xe máy là hai hạng bằng khác nhau. Do đó người
                          không có bằng lái xe máy vẫn được phép học bằng lái xe
                          ô tô.
                        </p>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ***** Frequently Question End ***** */}
      {/* ***** Contact Us Start ***** */}
      <section className="section" id="contact-us">
        <div className="container-fluid">
          <div className="row">
            {/* ***** Contact Map Start ***** */}
            <div
              className="col-lg-6 col-md-6 col-sm-12 wow fadeInLeft"
              style={{
                visibility: "visible",
                animationDuration: "0.5s",
                // animationDelay: "1s",
                animationName: "fadeInLeft",
              }}
            >
              <div id="map">
                {/* How to change your own map point
                   1. Go to Google Maps
                   2. Click on your location point
                   3. Click "Share" and choose "Embed map" tab
                   4. Copy only URL and paste it within the src="" field below
            */}
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.8746510288156!2d108.23137731526998!3d12.979868218207699!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTLCsDU4JzQ3LjUiTiAxMDjCsDE0JzAwLjgiRQ!5e0!3m2!1svi!2s!4v1611676904498!5m2!1svi!2s"
                  width="100%"
                  height="580px"
                  frameBorder={0}
                  style={{border: 0}}
                  allowFullScreen
                />
              </div>
            </div>
            {/* ***** Contact Map End ***** */}
            {/* ***** Contact Form Start ***** */}
            <div
              className="col-lg-6 col-md-6 col-sm-12 wow fadeInRight"
              style={{
                visibility: "visible",
                animationDuration: "1s",
                animationDelay: "1s",
                animationName: "fadeInRight",
              }}
            >
              <div className="contact-form" id="contact-form">
                <FormController />
              </div>
            </div>
            {/* ***** Contact Form End ***** */}
          </div>
        </div>
      </section>
      {/* ***** Contact Us End ***** */}
      {/* ***** Footer Start ***** */}
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-md-12 col-sm-12">
              <p className="copyright">
                Copyright © 2020 Art Factory Company . Design:
                <a rel="nofollow" href="#welcome">
                  Hai Dinh
                </a>
              </p>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12">
              <ul className="social">
                <li>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={facebookOwner}
                  >
                    <i className="fa fa-facebook" />
                  </a>
                </li>
                <li>
                  <a href={`tel:${phoneOwner}`}>
                    <i className="fa fa-phone" />
                  </a>
                </li>
                <li>
                  <a href={`mailto:${emailOwner}`}>
                    <i className="fa fa-envelope-o" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

      <div
        className="phonering-alo-phone phonering-alo-green phonering-alo-show"
        id="phonering-alo-phoneIcon"
      >
        <div className="phonering-alo-ph-circle" />
        <div className="phonering-alo-ph-circle-fill" />
        <a href={`tel:${phoneOwner}`} className="pps-btn-img" title="Liên hệ">
          <div className="phonering-alo-ph-img-circle" />
        </a>
      </div>
    </div>
  );
};
